<div mat-dialog-content class="link-to-loan">
    <h4 mat-dialog-title >Link to Loan Application</h4>
    <div class="Vert-20"></div>
    <span>Client</span><br>
    <strong>
        <p>{{clientData?.firstName}} {{clientData?.lastName}}</p>
    </strong>

    <lgv-loading-indicator *ngIf="isLoading$ | async; else showLoanApp" CSSClass="Small"></lgv-loading-indicator>

    <ng-template #showLoanApp>
        <form [formGroup]="linkedLoanAppForm">
        <mat-form-field appearance="outline" *ngIf="(loanApplications$ | async)?.length > 0; else noLoanApps">
            <mat-label>Select Loan</mat-label>
            <mat-select formControlName="loanApp" placeholder="View All">
                <ng-container *ngFor="let loanAppItem of (loanApplications$ | async)">
                    <mat-option [value]="loanAppItem">
                        {{loanAppItem?.loanInfo?.loanNumber ? 
                            loanAppItem?.loanInfo?.loanNumber : 
                            'Pending - ' + loanAppItem?.loanInfo?.purpose?.name + ', ' + loanAppItem?.loanInfo?.subjectPropertyAddress?.state}}
                    </mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>
        </form>
    </ng-template>

    <ng-template #noLoanApps>
        <p>Client has no existing loans to link.</p>
        <a (click)="openStartLoanApp()">+ New Loan Application</a>
    </ng-template>

    <div class="row">
        <div class="col-12" align="end">
            <button mat-button class="btn btn-primary float-end" (click)="onSubmit()"
                [disabled]="(linkedLoanAppForm?.invalid) && !(isLoading$ | async)"> Submit
            </button>
            <button mat-stroked-button (click)="dialogRef.close()" class="btn btn-secondary float-end" style="margin-right:10px;">
                Cancel </button>
        </div>
    </div>
</div>